import fs from 'node:fs'
import as from 'ansis'
import { Command } from 'commander'

import { normalize, toJson, toYaml } from '@scalar/openapi-parser'

import { getFileOrUrl, isUrl, isYamlFileName } from '@/domains/document/helpers'
import { output } from '@/helpers/std-out'

export function FormatCommand() {
  const cmd = new Command('format')

  cmd.description('Format an OpenAPI file')
  cmd.argument('[file|url]', 'File or URL to format')
  cmd.option('-o, --output <file>', 'Output file')
  cmd.action(
    async (
      inputArgument: string,
      { output: outputPath }: { output?: string },
    ) => {
      const startTime = performance.now()

      if (!inputArgument) {
        return output
          .error()
          .title('Invalid argument')
          .message('Please provide a file path')
          .exit('error')
      }
      const specification = await getFileOrUrl(inputArgument)

      const newContent = isYamlFileName(outputPath || inputArgument)
        ? toYaml(normalize(specification))
        : toJson(normalize(specification))

      // Replace file content with newContent
      if (outputPath) {
        fs.writeFileSync(outputPath, newContent, 'utf8')
      } else if (!isUrl(inputArgument)) {
        fs.writeFileSync(inputArgument, newContent, 'utf8')
      } else {
        return output
          .error()
          .title('Invalid argument')
          .message()
          .message(
            'Output file is required for URLs. Try passing --output file flag.',
          )
          .exit('error')
      }

      const endTime = performance.now()

      output
        .info()
        .line(
          `${as.green('File formatted')} ${as.grey(
            `in ${as.white(`${as.bold(`${Math.round(endTime - startTime)}`)} ms`)}`,
          )}`,
        )
        .print()
    },
  )

  return cmd
}
